export default {
  common__validation__is_required: '入力してください',
  common__validation__invalid_format: '正しい値を入力してください',
  common__validation__invalid_file_size: 'ファイルサイズが上限（{size}）を超えています',
};
